import React from 'react'
import {
    Table
} from 'react-bootstrap'

// convert platform versions to decimal format
const getVersionsAtDecimalFormat = (platform, item) => {
    try {
        return platform[item]['production']['version'].replace('.', '').replace('-', '')
    } catch(err) {
        return '0.0.0'
    }
}


// Get latest version of web platforms
const latestVersionOfWebPlatform = (platform, keys) => {
    // Get all versions
    const getVersions = keys.map(item => {
        const versions = getVersionsAtDecimalFormat(platform, item)
        return versions
    }).sort((a, b) => b - a)

    // Get latest release version
    const latestVersion = getVersions[0]

    // Get platform names which their version match latest release version
    const platforms = keys.filter(item => {
        const version = getVersionsAtDecimalFormat(platform, item)

        return version === latestVersion
    })

    // Get correct format of latest release version
    const getCorrectVersionFormat = keys.map(item => {
        const getVersions = getVersionsAtDecimalFormat(platform, item)
        if (getVersions === latestVersion) {
            return platform[item]['production']['version']
        } else {
            return null
        }
    }).filter((version, index, self) => version !== undefined && version !== null && index === self.indexOf(version)).join('')

    return { latestVersion: getCorrectVersionFormat, platforms }
}


// Get latest version of web platforms
const latestVersionOfAppPlatform = (data, keys) => {

    // Get all release versions
    const getVersions = keys.filter(platform => platform !== 'Roku').map(platform => {
        const versions = data[platform]

        return Object.keys(versions).map(platform => {
            return versions[platform] ? versions[platform]['version'].replace('.', '') : ''
        })
    })

    // Flatten all release versions
    const flattenVersions = []
    for (let version in getVersions) {
        getVersions[version].map(item => flattenVersions.push(item))
    }

    // Get only latest release version
    let latestVersion = flattenVersions.sort((a, b) => b - a)
    latestVersion = latestVersion[0]

    // Get platforms which their versions are match latest release version
    const platformsData = keys.filter(platform => platform !== 'Roku').map(platformName => {
        const versions = data[platformName]

        return Object.keys(versions).map(platform => {
            const version = versions[platform] ? versions[platform]['version'].replace('.', '') : ''
            if (version === latestVersion) {
                return platformName
            } else {
                return ''
            }
        })
    })

    // Flatten latest platform release names
    let platforms = []
    for (let version in platformsData) {
        for (let item in platformsData[version]) {
            platforms.push(platformsData[version][item])
        }
    }

    // Filter out only platform names
    platforms = platforms.filter(item => item.length > 0)

    // Get correct format of latest release version
    const getCorrectVersionFormat = keys.filter(platform => platform !== 'Roku').map(platform => {
        const versions = data[platform]
        let correctLatestVersionFormat;

        Object.keys(versions).map(platform => {
            if (versions[platform]['version'].replace('.', '') === latestVersion) {
                return correctLatestVersionFormat = versions[platform]['version']
            } else {
                return null
            }
        })
        return correctLatestVersionFormat
    }).filter(version => version !== undefined && version !== null)[0]

    return { latestVersion: getCorrectVersionFormat, platforms }
}


// Get latest version of Roku platforms
const latestVersionOfRokuPlatform = (platform, keys) => {
    // Get latest release version
    const latestVersion = keys.map(() => {
        return Object.values(platform['Roku'])[0]['version']
    }).filter((version, index, self) => version !== undefined && version !== null && index === self.indexOf(version))
        .sort((a, b) => b - a)[0]

    return { latestVersion, platforms: ['Roku'] }
}


// Render the data to different platforms to display more than one component with different platforms data
const getDifferentPlatformData = (webPlatform, appPlatform, data) => {

    const dataProperties = data ? Object.keys(data) : {}

    if (webPlatform) {
        return latestVersionOfWebPlatform(data, dataProperties)
    } else if (appPlatform) {
        return latestVersionOfAppPlatform(data, dataProperties)
    } else {
        return latestVersionOfRokuPlatform(data, dataProperties)
    }
}


const LatestReleasePlatform = ({ webPlatform, appPlatform, platformType, data }) => {
    const platformsData = getDifferentPlatformData(webPlatform, appPlatform, data)

    return (
        <Table bordered hover>
            <thead>
                <tr>
                    <th>
                        Latest release {platformType}
                    </th>
                    <th colSpan="6">
                        {platformsData.latestVersion}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th>Platform</th>
                    {platformsData.platforms.map((platform, index) => platform.length > 0 ? <td key={platform + index}>{platform}</td> : null)}
                </tr>
            </tbody>
        </Table>
    )
}

LatestReleasePlatform.defaultProps = {
    webData: {},
    appsData: {},
    platformType: '',
    webApp: false
}

export default LatestReleasePlatform



// WEBPACK FOOTER //
// ./src/components/LatestReleasePlatform.js